import {Badge, Drawer, Menu} from 'antd';
import React, {useMemo} from 'react';
import {useLocation} from 'react-router';
import {Link} from 'react-router-dom';

import connector from './connector';
import {CONSTANTS, isClientTrial} from '../../libs/ui/src';

import {UnorderedListOutlined, UserOutlined, InboxOutlined, FileTextOutlined, VideoCameraOutlined} from '@ant-design/icons';

import './navigation.scss';
import {InboxNavigation as getInboxNavigation} from './inboxNavigation';
import { isPaidClient } from '../../utils';


// TODO MM chat gpt

const MobileNavigation = ({
  isNavCollapsed,
  setSettings,
  client,
  users,
  unreadCountByUser,
  inboxLoading,
  isAdmin,
  openMenuItems,
}: any) => {
  const location = useLocation();
  const pages = getPages(client, isAdmin);
  const filteredPathname = `/${location.pathname.split('/')[1]}`;
  const selectedInboxUser = location.pathname.split('/').pop();

  const selectedKeys = useMemo(() => {
    const array = pages.reduce(
      (acc, item) => (item.path === filteredPathname ? acc.concat(item.key) : acc),
      [] as string[]
    );
    if (array[0] === CONSTANTS.inbox_page_key) {
      array.push(selectedInboxUser);
    }
    return array;
  }, [pages, filteredPathname, selectedInboxUser]);

  const items = pages.map(page => {
    if (page.key === 'inbox') {
      return getInboxNavigation({
        page,
        client,
        users,
        unreadCountByUser,
        inboxLoading,
        selectedInboxUser,
        openMenuItems,
        setSettings,
        isNavCollapsed,
      });
    }
    return ({
      label: (
        <Link to={page.path}>
          <span>
            {page.label}
          </span>
        </Link>
      ),
      key: page.key,
      icon: page.icon,
    })
  });

  return (
    <Drawer
      placement="left"
      className="mobile_menu_container"
      closable={false}
      onClose={() => setSettings({isNavCollapsed: !isNavCollapsed})}
      open={!isNavCollapsed}
      getContainer={false}
      style={{position: 'absolute'}}
    >
      <Menu
        onSelect={() => setSettings({isNavCollapsed: !isNavCollapsed})}
        className="menu-tabs"
        mode="inline"
        theme="light"
        openKeys={openMenuItems}
        selectedKeys={selectedKeys}
        items={items}
      />
    </Drawer>
  );
};

function getPages(client: any, isAdmin: boolean) {
  const excludeList: any = [];
  const isTrialSubscription = isClientTrial(client.type);
  if (isTrialSubscription) {
    excludeList.push('Prospects');
  }
  if (!client.inbox_feature) {
    excludeList.push('Inbox');
  }
  if (!isAdmin) {
    // excludeList.push('Audience');
  }

  if(!isPaidClient(client)) {
    excludeList.push('Audience Lists');
    excludeList.push('Product Demos');
    excludeList.push('CRM');
  }

  return pageList.filter((page: any) => !excludeList.find((excludeLabel: any) => excludeLabel === page.label));
}

const pageList = [
  {label: 'Campaigns', path: '/', icon: <UnorderedListOutlined />, key: 'campaigns'},
  {label: 'Users', path: '/users', icon: <UserOutlined />, key: 'users'},
  {label: 'CRM', path: '/crm', icon: <UserOutlined />, key: 'crm'},
  {label: 'Inbox', path: '/inbox', icon: <InboxOutlined />, key: 'inbox'},
  {label: 'Templates', path: '/templates', icon: <FileTextOutlined />, key: 'templates'},
  {label: 'Product Demos', path: '/demos', icon: <VideoCameraOutlined />, key: 'demos'},
  {label: 'Audience Lists', path: '/audience-lists', icon: <UserOutlined />, key: 'audience-lists'},
  {label: 'Lead Enrichment', path: '/lead-enrichment', icon: <UserOutlined />, key: 'lead-enrichment'},
];

export default connector(MobileNavigation);
